import {WwsUmsatzstatistikOptionenListStore} from './abstractions/optionen-list.store';

export const WwsUmsatzstatistikUmsatzartStore = new WwsUmsatzstatistikOptionenListStore<{ umsatzart: string }>();
